module.exports = __webpack_public_path__ + "img/product-card-hero-sm.2697088.webp";